import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import type { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';
import { UmmeldungStore } from '../../store';
import { WIZARD_CONTROLLER, WizardBeforeNavigationEvent, WizardContext, WizardEventType } from '@mwe/features/wizard';
import { IkpPopupService } from '@shared-ikp/service/popup/popup.service';

@Component({
  selector: 'ikp-save-and-close-ummeldung-button',
  imports: [TranslatePipe, NgOptimizedImage],
  templateUrl: './save-and-close-button-ummeldung-wizard.component.html',
  styleUrl: './save-and-close-button-ummeldung-wizard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveAndCloseButtonUmmeldungWizardComponent {
  private readonly ummeldungStore = inject(UmmeldungStore);
  private readonly wizardController = inject(WIZARD_CONTROLLER);
  private readonly wizardContext = inject(WizardContext, { optional: true });
  private readonly popupService = inject(IkpPopupService);

  protected readonly isLoading = computed(() => this.ummeldungStore.loading());

  onClick(): void {
    if (this.isLoading() || !this.isCurrentStepFormValid()) {
      return;
    }

    //We need to trigger the BeforeNextStepNavigation event to ensure that all steps have the chance to update the store with their current form values before we save the Ummeldung.
    this.wizardController.events$.next(
      new WizardBeforeNavigationEvent(WizardEventType.BeforeNextStepNavigation, this.wizardController.currentStep()),
    );

    this.ummeldungStore.saveActiveUmmeldung().subscribe({
      next: () => this.wizardController.close('finished'),
      error: () => {
        console.error('[SaveAndCloseButtonUmmeldungWizardComponent] Error saving Ummeldung');
        this.popupService.handleErrorPopup('save-ummeldung-error', 'ummeldung.saveErrorPopup.title', 'ummeldung.saveErrorPopup.message');
      },
    });
  }

  private isCurrentStepFormValid(): boolean {
    const form = (this.wizardContext?.currentComponent()?.instance as { form?: AbstractControl } | undefined)?.form;
    form?.updateValueAndValidity();
    return !form || form.valid;
  }
}
